<template>
  <FormGroup>
    <Text variant="body-large" color="secondary">Choose a day and time to suggest to the renters</Text>

    <FormField :error="form.fieldErrors('date')">
      <LineDatePicker v-model="form.fields.date" />
    </FormField>

    <FormField label="Time" :error="form.fieldErrors('time')">
      <Select v-model="form.fields.time">
        <option v-for="time in timeOptions" :key="time">{{ time }}</option>
      </Select>
    </FormField>

    <FormField label="Showing will be held by" :error="form.fieldErrors('showingAgentId')">
      <ShowingAgentPicker v-model="form.fields.showingAgentId" />
    </FormField>

    <FormField label="Leave a comment for the renters" hint="Optional" :error="form.fieldErrors('comment')">
      <Textarea placeholder="Type your comment here" rows="3" v-model="form.fields.comment" />
    </FormField>
  </FormGroup>
</template>

<script setup lang="ts">
import { UnwrapNestedRefs } from 'vue';

import { Select, Textarea, LineDatePicker, Text, FormField, FormGroup, FormComposable } from '@tallo/design-system';
import { ShowingAgentPicker } from '@tallo/investor/showing-agents';

import { timeOptions } from '../time-options.const';

interface RescheduleShowingFormModel {
  showingAgentId: string;
  comment: string;
  date: Date | undefined;
  time: string | undefined;
}

const form = defineModel<UnwrapNestedRefs<FormComposable<RescheduleShowingFormModel>>>('form', { required: true });
</script>
